import breakpointMap from '../../../../tokens/screens.tailwind.json';
import { html } from 'lit';
import componentStyles from './responsive-image.css.lit.ts';
import { ifDefined } from 'lit-html/directives/if-defined';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

/**
 * A block with image left, content right. Content is handled by promo-text
 * component. See list of color variants.
 *
 * @element hf-responsive-image
 */

export default class ResponsiveImage extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * If image is mostly decorative, adds role="presentation".
       */
      imagePresentation: { type: Boolean },
      imageStyle: { type: String },
    };
  }

  constructor() {
    super();
    this.imagePresentation = false;
    this.imageFill = 'width';
  }

  render() {
    return html`
      <div class="responsive-image image-fill--${this.imageStyle}">
        <slot name="image"></slot>
      </div>
    `;
  }
}

customElements.define('hf-responsive-image', ResponsiveImage);
